
export const resolveLocale = (localeOriginal: string | string[] | undefined): string | undefined => {
    let locale: string | undefined;
    if (Array.isArray(localeOriginal) && localeOriginal.length > 0) {
        locale = localeOriginal[0];
    } else if (typeof localeOriginal === 'string') {
        locale = localeOriginal;
    }
    return locale;
};

export const resolveLanguage = (locale: string | string[] | undefined): string => {
    return resolveLocale(locale)?.split(/[_-]/)?.[0] || 'en';
}

export const resolveCountry = (locale: string | string[] | undefined): string | undefined => {
    return resolveLocale(locale)?.split(/[_-]/)?.[1]?.toUpperCase();
}